import { render, staticRenderFns } from "./lectureTopicViewer.vue?vue&type=template&id=64e14582&scoped=true&"
import script from "./lectureTopicViewer.vue?vue&type=script&lang=js&"
export * from "./lectureTopicViewer.vue?vue&type=script&lang=js&"
import style0 from "./lectureTopicViewer.vue?vue&type=style&index=0&id=64e14582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e14582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
